function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Klientska-zona",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "WishMaker-Registracny-Proces_Investor-0",
  transform: "translate(-634.000000, -629.000000)",
  stroke: "#F7931E",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(318.000000, 226.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(24.000000, 104.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Input_Default",
  transform: "translate(0.000000, 284.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(292.600583, 14.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "upload-cloud",
  transform: "translate(0.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "16 13 12 9 8 13"
}), /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 9,
  x2: 12,
  y2: 18,
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.39,15.39 C22.3963878,14.2961756 23.4058732,11.9812616 22.8422071,9.76669062 C22.278541,7.55211965 20.2851787,6.00150875 18,6 L16.74,6 C15.9110812,2.79381476 13.1924313,0.429775738 9.90220351,0.0541009621 C6.61197575,-0.321573814 3.43039912,1.3687835 1.90007949,4.30559334 C0.369759869,7.24240319 0.807078934,10.818503 3,13.3",
  id: "Path"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "16 13 12 9 8 13"
})))))))));

var SvgUploadCloud = function SvgUploadCloud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "20px",
    viewBox: "0 0 25 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUploadCloud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload-cloud.f442822e.svg";
export { ForwardRef as ReactComponent };